import { postVerifyAttachment, postExtractAttachment } from '../api';

import {
  AttachmentImage,
  AttachmentLink,
  AttachmentVerifyResult,
  AttachmentExtractResult,
  ConversationAttachmentType,
} from '../types';

interface IProps {
  npcId: number;
  attachmentType: ConversationAttachmentType;
  fromWorkspace?: boolean;
  image?: AttachmentImage;
  link?: AttachmentLink;
}

export const attachmentCheck = async ({
  npcId,
  attachmentType,
  fromWorkspace,
  image,
  link,
}: IProps) => {
  try {
    const { result, reject_desc } = await postVerifyAttachment({
      npc_id: npcId,
      attachment_type: attachmentType,
      from_workspace: fromWorkspace,
      image,
      link,
    });

    if (result !== AttachmentVerifyResult.Passed) {
      throw Error(reject_desc);
    }

    const {
      result: eResult,
      reject_desc: eRejectDesc,
      image_desc,
    } = await postExtractAttachment({
      npc_id: npcId,
      attachment_type: attachmentType,
      from_workspace: fromWorkspace,
      image,
      link,
    });

    if (eResult !== AttachmentExtractResult.Passed) {
      throw Error(eRejectDesc);
    }

    return {
      image_desc,
    };
  } catch (err: any) {
    throw Error(err.status_msg || err.message);
  }
};
